import { render, staticRenderFns } from "./navDrawerForStudentPanel.vue?vue&type=template&id=21008204&"
import script from "./navDrawerForStudentPanel.vue?vue&type=script&lang=js&"
export * from "./navDrawerForStudentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports